import { supabaseGetter } from '~/api/supabase-getter'

/**
 * Validates an invite ticket and returns its payload.
 *
 * @param {string} ticketId
 * @returns {{ valid: boolean, organizationId?: string, role?: string, expiresAt?: Date, error?: string }}
 */
export const validateInviteTicket = async (ticketId) => {
  if (!ticketId) return { valid: false, error: 'No invite ticket provided' }

  const { data: ticket, error } = await supabaseGetter.inviteTickets.getById(ticketId)

  if (error || !ticket) {
    return { valid: false, error: 'Invalid invite link' }
  }

  // Already used — invite_ticket_activations has a UNIQUE(ticket_id) constraint
  if (ticket.invite_ticket_activations && ticket.invite_ticket_activations.length > 0) {
    return { valid: false, error: 'Invite already used' }
  }

  const expiresAt = new Date(ticket.expires_at)
  if (expiresAt < new Date()) {
    return { valid: false, error: 'Invite link expired', expiresAt }
  }

  return {
    valid: true,
    organizationId: ticket.organization_id,
    role: ticket.role,
    expiresAt,
  }
}
